import httpAxios from "@/axios";
import { ApiAsync, ApiAsyncHelper } from "./ApiAsync";

// const httpAxios = Axios.create({
//     baseURL: process.env.VUE_APP_BASE_URL && process.env.VUE_APP_BASE_URL !== '' && process.env.VUE_APP_BASE_URL !== null ? process.env.VUE_APP_BASE_URL : 'http://localhost:8888'
// });

// httpAxios.defaults.headers.common['Authorization'] = 'Bearer ' +localStorage.getItem("token");

/**
 * Standard API request to get all entries
 * @param {*} basePath
 */
const All = (basePath, model) => {
  return ({ commit, dispatch }, params) => {
    httpAxios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("token");

    return new Promise((resolve, reject) => {
      httpAxios
        .get(basePath + "/all", params)
        .then((response) => {
          if (model) {
            response.data.data = response.data.data.map((Entry) => {
              return new model(Entry);
            });
            resolve(response.data.data);
          } else {
            resolve(response.data.data);
          }
        })
        .catch(function(error) {
          if (process.env.NODE_ENV === "development") {
            console.error(error);
          }
          reject(error.response.data);
        });
    });
  };
};

/**
 * Standard API request to get a paginated subset of entries
 * @param {*} basePath
 */
const List = (basePath, model) => {
  return ({ commit, dispatch }, params) => {
    httpAxios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("token");

    return new Promise((resolve, reject) => {
      httpAxios
        .get(basePath, { params: params })
        .then((response) => {
          resolve(response.data.data);
        })
        .catch(function(error) {
          if (process.env.NODE_ENV === "development") {
            console.error(error);
          }
          reject(error.response.data);
        });
    });
  };
};

/**
 * Standard API request to get a single entry
 */
const Show = (basePath, model) => {
  httpAxios.defaults.headers.common["Authorization"] =
    "Bearer " + localStorage.getItem("token");

  return ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      let Id = params.id ? params.id : null;

      if (typeof params === 'string') {
        Id = params;
      } else {
        delete params.id;
      }

      httpAxios
        .get(basePath + "/" + Id, { params: params ? params : {} })
        .then((response) => {
          resolve(response.data.data);
        })
        .catch(function(error) {
          if (process.env.NODE_ENV === "development") {
            console.error(error);
          }
          reject(error.response.data);
        });
    });
  };
};

/**
 * Standard API request to create single element
 * @param {*} basePath
 */
const Create = (basePath, model) => {
  httpAxios.defaults.headers.common["Authorization"] =
    "Bearer " + localStorage.getItem("token");

  return ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      httpAxios
        .post(basePath, params)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch(function(error) {
          if (process.env.NODE_ENV === "development") {
            console.error(error);
          }
          reject(error.response.data);
        });
    });
  };
};

/**
 * Standard API request to udpate single entry
 * @param {*} basePath
 */
const Update = (basePath, model) => {
  httpAxios.defaults.headers.common["Authorization"] =
    "Bearer " + localStorage.getItem("token");

  return ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      let Id = params.id ? params.id : null;

      if (typeof params === 'string') {
        Id = params;
      } else {
        delete params.id;
      }

      httpAxios
        .put(basePath + "/" + Id, params ? params : {})
        .then((response) => {
          resolve(response.data.data);
        })
        .catch(function(error) {
          if (process.env.NODE_ENV === "development") {
            console.error(error);
          }
          reject(error.response.data);
        });
    });
  };
};

/**
 * Standard API request to delete an entry
 * @param {*} basePath
 */
const Destroy = (basePath, model) => {
  httpAxios.defaults.headers.common["Authorization"] =
    "Bearer " + localStorage.getItem("token");

  return ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      let Id = params.id ? params.id : null;

      if (typeof params === 'string') {
        Id = params;
      } else {
        delete params.id;
      }

      httpAxios
        .delete(basePath + "/" + Id, { params: params ? params : {} })
        .then((response) => {
          resolve(response.data.data);
        })
        .catch(function(error) {
          if (process.env.NODE_ENV === "development") {
            console.error(error);
          }
          reject(error.response.data);
        });
    });
  };
};

/**
 * Helper to register multiple calls at once
 * @param {*} basePath
 * @param {*} except
 * @param {*} others
 */
const BaseApiRoutes = (basePath, except, others, model) => {
  let name = null;

  // Fallback if base path is not set
  if (basePath === undefined || basePath === null) {
    return others !== undefined ? others : {};
  }

  if (except === undefined || except === null || except === "") {
    except = [];
  }

  for (name in AllMethods) {
    if (except.indexOf(name) === -1) {
      others[name] = AllMethods[name](basePath, model);
    }
  }

  return others;
};

const BaseApiGetters = (basePath, model, hooks, custom, usecache) => {
  return {
    api: () => {
      return new ApiAsync(basePath, model, hooks, custom, usecache);
    },
  };
};

/**
 * Subset of possible Methods of this class
 */
const AllMethods = {
  getAll: All,
  getList: List,
  getEntry: Show,
  createEntry: Create,
  destroyEntry: Destroy,
  updateEntry: Update,
};

export {
  All,
  List,
  Show,
  Create,
  Destroy,
  Update,
  BaseApiRoutes,
  BaseApiGetters,
  ApiAsyncHelper,
};
